export default function Matplotlib_Grid() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibGrid Component</h1>
      <p>This is the MatplotlibGrid component.</p>
    </div>
  );
}
